import React from "react"
import { Icon } from "../icon"
import { cn } from "../utils"

// =============================================================================
// Styles
// =============================================================================
const chevronStyles = [
  "shrink-0 transition-[rotate,color] ease-out motion-reduce:transition-none",
  "group-data-panel-open/collapsible-trigger:-rotate-180"
]

// =============================================================================
// Props
// =============================================================================
export type CollapsibleChevronProps = {
  /** Additional CSS classes, such as a colour */
  className?: string
}

// =============================================================================
// Component
// =============================================================================
/**
 * The down chevron, turned up while the content is open. The default
 * `Collapsible.Trigger` adds one itself; place it inside the element passed
 * as `render` to give a custom trigger one. Hidden from screen readers, since
 * the trigger's `aria-expanded` already carries the state.
 */
export function CollapsibleChevron({ className }: CollapsibleChevronProps) {
  return (
    <Icon
      name="down"
      data-slot="collapsible-chevron"
      data-icon="inline-end"
      className={cn(chevronStyles, className)}
    />
  )
}

CollapsibleChevron.displayName = "Collapsible.Chevron"
